import { render, staticRenderFns } from "./PaginationMod.vue?vue&type=template&id=9d1f1ab8"
import script from "./PaginationMod.vue?vue&type=script&lang=js"
export * from "./PaginationMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports